import styled from 'styled-components';

const BlogPostHeaderStyles = styled.header`
  padding: 3.75rem 0 2.5rem;
  text-align: center;

  .title {
    max-width: 37rem;
    margin: 0 auto;
    padding: 1rem 0;
  }

  .categories {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    margin: 1.5rem 0 0.3rem;
    padding: 0;
    list-style: none;

    .category {
      margin-bottom: 1rem;
      font-size: 0.9rem;
      font-weight: var(--font-weight-medium);
      color: var(--color-bark);
      text-transform: uppercase;
      background-color: var(--color-sand);
      padding: 0.75rem;
    }
  }

  .meta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-top: 0.5rem;
    opacity: 0.7;

    .date,
    .reading-time {
      margin: 0;
    }
  }

  @media (min-width: 768px) {
    padding: 5.5rem 4.25rem;
  }
`;

export default BlogPostHeaderStyles;
